'use strict';

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp2;

exports["default"] = function (_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ['theme']);

  var component = _react2["default"].createElement(Card, props);

  return theme ? _react2["default"].createElement(_util.ThemeProvider, {
    theme: theme
  }, component) : component;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Flag = require('./Flag');

var _Flag2 = _interopRequireDefault(_Flag);

var _CardMeta = require('./CardMeta');

var _CardMeta2 = _interopRequireDefault(_CardMeta);

var _cards = require('../cards');

var _util = require('../util');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var styles = function styles(theme) {
  return {
    _root: {},
    _active: {},
    root: {
      fontFamily: theme.fontPrimary,
      color: theme.colorText,
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignContent: 'space-between',
      background: theme.bgCard,
      border: theme.cardBorder,
      borderRadius: theme.cardBorderRadius,
      boxShadow: theme.cardShadow,
      margin: [[40, 'auto', 0, 'auto']],
      maxWidth: theme.cardMaxWidth,
      minHeight: theme.cardMinHeight,
      minWidth: theme.minWidth,
      position: 'relative'
    },
    '@media(max-width: 52em)': {
      root: {
        marginTop: 60,
        maxWidth: '100%',
        minWidth: 'auto'
      }
    },
    active: {
      outline: [[2, 'solid']]
    },
    accept: {
      borderColor: theme.accept,
      outlineColor: theme.accept
    },
    reject: {
      borderColor: theme.reject,
      outlineColor: theme.reject
    },
    ignore: {
      borderColor: theme.ignore,
      outlineColor: theme.ignore
    }
  };
};

var Card = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(Card, _React$Component);

  function Card() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Card);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Card.__proto__ || Object.getPrototypeOf(Card)).call.apply(_ref2, [this].concat(args))), _this), _this.componentWillMount = function () {
      if (_this.props.config.javascript) {
        _this.updateGlobals(_this.props);

        var script = document.createElement('script');
        script.textContent = _this.props.config.javascript;
        document.body.appendChild(script);
      }

      if (_this.props.config.global_css_url) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = _this.props.config.global_css_url;
        document.head.appendChild(link);
      }

      if (_this.props.config.global_css) {
        var style = document.createElement('style');
        style.textContent = _this.props.config.global_css;
        document.head.appendChild(style);
      }
    }, _this.componentDidMount = function () {
      return document.dispatchEvent(new CustomEvent('prodigymount'));
    }, _this.componentDidUpdate = function () {
      document.dispatchEvent(new CustomEvent('prodigyupdate', {
        detail: {
          task: _this.props.content
        }
      }));

      if (_this.props.config.javascript) {
        _this.updateGlobals(_this.props);
      }
    }, _this.updateGlobals = function (_ref3) {
      var viewId = _ref3.viewId,
          config = _ref3.config,
          content = _ref3.content,
          updateQuestion = _ref3.updateQuestion,
          handleAnswer = _ref3.handleAnswer,
          theme = _ref3.theme;
      window.prodigy = {
        viewId: viewId,
        config: config,
        content: content,
        update: updateQuestion,
        answer: handleAnswer,
        theme: theme
      };
    }, _this.flagTask = function (ev) {
      var viewConfig = (0, _util.getConfig)(_this.props.config, _this.props.content);

      if (viewConfig.showFlag) {
        _this.props.updateQuestion({
          flagged: !Boolean(_this.props.content.flagged)
        });
      }
    }, _this.getInterfaceComp = function () {
      var task = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var view_id = (0, _util.findInterface)(task);
      var Component = _cards.INTERFACES[view_id];
      return _react2["default"].createElement(Component, _extends({
        content: task
      }, props));
    }, _this.handleShortcuts = function (action, ev) {
      switch (action) {
        case 'flag':
          _this.flagTask();

          break;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Card, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          viewId = _props.viewId,
          content = _props.content,
          config = _props.config,
          updateQuestion = _props.updateQuestion,
          handleAnswer = _props.handleAnswer,
          indicateAction = _props.indicateAction,
          translate = _props.translate,
          ToolbarButton = _props.ToolbarButton,
          SessionTag = _props.SessionTag,
          ChoiceOption = _props.ChoiceOption,
          classes = _props.classes,
          children = _props.children;
      var viewConfig = (0, _util.getConfig)(config, content);

      var Component = _cards.INTERFACES[viewId || (0, _util.findInterface)(content)];

      var shortcutProps = {
        name: 'ACTIONS',
        handler: this.handleShortcuts,
        targetNodeSelector: 'body',
        global: true
      };
      var rootClassNames = (0, _classnames2["default"])('prodigy-container', classes.root, classes._root, (_classNames = {}, _defineProperty(_classNames, classes.active, !!indicateAction), _defineProperty(_classNames, classes._active, !!indicateAction), _defineProperty(_classNames, classes[indicateAction], !!indicateAction), _classNames));

      var translateFunc = function translateFunc(id, fallback, args) {
        return translate ? translate(id, args) : fallback || id;
      };

      return Component ? _react2["default"].createElement('div', {
        className: rootClassNames
      }, _react2["default"].createElement(_util.ShortcutsWrapper, _extends({
        ctx: this.context.shortcuts
      }, shortcutProps), _react2["default"].createElement(_Flag2["default"], {
        visible: viewConfig.showFlag,
        onClick: this.flagTask,
        active: content.flagged,
        title: translateFunc('flag')
      })), _react2["default"].createElement(Component, {
        content: content,
        config: viewConfig,
        update: updateQuestion,
        answer: handleAnswer,
        translate: translateFunc,
        getInterfaceComp: this.getInterfaceComp,
        ToolbarButton: ToolbarButton,
        SessionTag: SessionTag,
        ChoiceOption: ChoiceOption
      }, children), _react2["default"].createElement(_CardMeta2["default"], {
        visible: content.meta && !viewConfig.hideTaskMeta,
        wide: viewId === 'review',
        content: content.meta
      })) : null;
    }
  }]);

  return Card;
}(_react2["default"].Component), _class2.defaultProps = {
  config: {}
}, _class2.propTypes = {
  viewId: _propTypes2["default"].string,
  content: _propTypes2["default"].object,
  config: _propTypes2["default"].object,
  updateQuestion: _propTypes2["default"].func,
  handleAnswer: _propTypes2["default"].func,
  indicateAction: _propTypes2["default"].oneOf(['accept', 'reject', 'ignore']),
  translate: _propTypes2["default"].func
}, _class2.contextTypes = {
  shortcuts: _propTypes2["default"].object
}, _temp2)) || _class);